module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [(_vm.bundleSharingEnableFlag) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-2x push-15-r "
  })]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplaySubBundle === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySubBundle) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplaySubBundle) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].ReferenceName),
      expression: "tempoBundle.sub_bundle[subBundleIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 push"
  }, [_c('p', [_vm._v(_vm._s(_vm.sectionTitleDisplayMA[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue),
      expression: "tempoBundle.sub_bundle[subBundleIndex].computeSumOfMovingAverageValue"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue) ? _vm._i(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue, null) > -1 : (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempoBundle.sub_bundle[_vm.subBundleIndex].computeSumOfMovingAverageValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "computeSumOfMovingAverageValue", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "computeSumOfMovingAverageValue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex], "computeSumOfMovingAverageValue", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.buttonLabelMA_Option[_vm.actualLanguage]) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group appliance-list-wrap"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "100px",
      "src": _vm._f("s3Image")(("systems_icons/" + (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData.bundle_icon)))
    },
    on: {
      "click": function($event) {
        _vm.showSystemsList = !_vm.showSystemsList
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-big btn-primary btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showSystemsList = !_vm.showSystemsList
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.showSystemsList) ? _c('systems-list', {
    staticClass: "systems-list",
    on: {
      "onSelect": _vm.onSystemSelect
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.actualBundle.channelsAttributes.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.sectionLabelSubSystemTag[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-select"
      }
    }, [_vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].Attributes[index]),
        expression: "tempoBundle.sub_bundle[subBundleIndex].Attributes[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-select",
        "name": "example-select",
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].Attributes, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((categoryList.data), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.bundleConfigViewFlag) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('h5', [_vm._v(_vm._s(_vm.labelSectionSubSystemConfiguration[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelSubSystemName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData.bundle_name),
      expression: "tempoBundle.sub_bundle[subBundleIndex].subBundleData.bundle_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData.bundle_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.sub_bundle[_vm.subBundleIndex].subBundleData, "bundle_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [(_vm.bundleConfigDeleteFlag) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "name": "buttonDeletePlanItem2"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveSubBundle()
      }
    }
  }, [(_vm.subBundleIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteSystem[_vm.actualLanguage]))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [(_vm.bundleConfigEditFlag) ? _c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSubBundleModifications()
      }
    }
  }, [(_vm.subBundleIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonSaveThisSubSystem[_vm.actualLanguage]))])], 1) : _vm._e()])])])]) : _vm._e()])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfc27ab8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/ConfigSubBundle.vue
// module id = 1583
// module chunks = 4